import * as React from "react";

function SvgComponent(props) {
  return <svg id="svg7384" style={{
    enableBackground: "new"
  }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><title id="title8473">{"Gnome Symbolic Icons"}</title><defs id="defs7386" /><g id="layer10" transform="translate(-292,-72)" /><g id="layer1" transform="translate(-292,-8)"><path d="m 300,9.005859 c -2.049,0 -4.09825,0.779891 -5.65625,2.337891 -3.116,3.116 -3.116,8.1965 0,11.3125 a 1,1 0 0 0 1.69922,-0.890625 c 0.1415,-0.02719 0.28041,-0.09646 0.39648,-0.216797 l 2.72461,-2.732422 A 2,2 0 0 0 300,19 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 2,2 0 0 0 -2,2 2,2 0 0 0 0.13477,0.716797 l -2.75977,2.769531 c -0.0532,0.05206 -0.0879,0.117606 -0.12305,0.181641 A 5.984,5.984 0 0 1 294.01562,17.5 H 295 v -1 h -0.98438 a 5.984,5.984 0 0 1 1.40235,-3.375 l 0.69336,0.693359 0.70703,-0.707031 -0.69141,-0.691406 A 5.984,5.984 0 0 1 299.5,11.015625 V 12 h 1 v -0.984375 a 5.984,5.984 0 0 1 3.375,1.402344 l -0.69141,0.693359 0.70703,0.707031 0.69141,-0.693359 a 5.984,5.984 0 0 1 1.40235,3.375 H 305 v 1 h 0.98438 a 5.984,5.984 0 0 1 -1.40235,3.375 l -0.69336,-0.693359 -0.70703,0.707031 0.79688,0.796875 a 1,1 0 0 0 1.67773,0.970703 c 3.116,-3.116 3.116,-8.1965 0,-11.3125 A 7.975,7.975 0 0 0 300,9.005859 Z" id="path2-1" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        display: "inline",
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000000",
        solidOpacity: 1,
        fill: "#2e3436",
        fillOpacity: 1,
        stroke: "none",
        marker: "none"
      }} /></g><g id="layer11" transform="translate(-292,-72)" /><g id="layer7" transform="translate(-292,-8)" /><g id="layer6" transform="translate(-292,-8)" /><g id="layer5" transform="translate(-292,-8)" /><g id="layer9" transform="translate(-292,-8)" /><g id="layer2" transform="translate(-292,-8)" /><g id="layer8" transform="translate(-292,-8)" /><g id="layer3" transform="translate(-292,-8)" /><g id="layer4" transform="translate(-292,-8)" /></svg>;
}

export default SvgComponent;